var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content"},[_c('div',[_c('a-input-search',{staticClass:"search-input",staticStyle:{"width":"300px"},attrs:{"placeholder":"Mata in söktext"},on:{"change":_vm.onSearch}})],1),_c('STable',{attrs:{"settings":_vm.tableSettings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }